/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  makeStyles,
  InputLabel,
  withStyles,
  useMediaQuery,
} from "@material-ui/core";
import CheckboxComponent from "app/common/CheckboxComponent";
import { AiOutlineTags, AiOutlineShop } from "react-icons/ai";
import _ from "lodash";
import moment from "moment";
import { GoLocation } from "react-icons/go";
import withExportElasticities from "./WithExportElasticities";
import withExportDemandPredictions from "../../demand/export_excel/WithExportDemandPredictions";
import ExportPreview from "./ExportPreview";
import ElasticityTypeToggle from "./ElasticityTypeToggle";
import SelectComponent from "../SelectComponent";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  dialogContent: {
    width: "100%",
    height: "100%",
    padding: "25px",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
  },
  dialogContentSmall: {
    width: "80%",
    height: "100%",
    padding: "25px",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
  },
  dialogActions: {
    // borderTop: theme.box.border,
    marginBottom: "12px",
    marginRight: "10.5%",
  },
  dialogRoot: {
    maxWidth: "450px",
  },
  inputSelectContainer: {
    width: "85%",
    marginBottom: "18px",
    paddingLeft: "3px",
  },
  inputSelect: {
    height: "50px",
  },
  inputLabel: {
    color: "gray",
    width: "83%",
  },
  inputLabelAggregation: {
    color: "gray",
    width: "83%",
    marginBottom: "12px",
    marginTop: "5px",
  },
  dialogText: {
    marginTop: "15px",
    marginBottom: "15px",
    paddingLeft: "25px",
  },
  ckeckByDate: {
    marginBottom: "30px",
  },
}));

const StyledInputLabel = withStyles(() => ({
  root: {
    fontSize: "13px",
  },
}))(InputLabel);

const StyledDialogTitle = withStyles(() => ({
  root: {
    padding: "0px",
  },
}))(DialogTitle);

const ExportElasticitiesCard = ({
  open = false,
  handleClose,
  minDate,
  maxDate,
  excelGroupBy,
  setExcelGroupBy,
  excelGroupByTwo,
  setExcelGroupByTwo,
  checkboxChecked,
  setCheckboxChecked,
  isDemandPlanning,
}) => {
  const classes = useStyles();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const minDateFormat = moment(minDate).format("MMM'YY");

  const maxDateFormat = moment(maxDate).format("MMM'YY");

  const staticFields = !isDemandPlanning
    ? [
        {
          id: 1,
          key: "date",
          field: "Date",
          tooltip: "Date",
        },
        checkboxChecked === true
          ? {
              id: 2,
              key: "staticTwo",
              field: "Elasticity",
              tooltip: `Elasticity ${minDateFormat}-${maxDateFormat}`,
            }
          : {
              id: 3,
              key: "staticTwo",
              field: "Avg Elasticity",
              tooltip: `Average elasticity ${minDateFormat}-${maxDateFormat}`,
            },

        { id: 4, key: "product", field: "Product", tooltip: "Product" },
        { id: 5, key: "product", field: "Product UPC", tooltip: "Product UPC" },
        { id: 6, key: "retailer", field: "Retailer", tooltip: "Retailer" },
        { id: 7, key: "category", field: "Category", tooltip: "Category" },
        { id: 8, key: "line", field: "Line", tooltip: "Line" },
        { id: 9, key: "brand", field: "Brand", tooltip: "Brand" },

        { id: 10, key: "area", field: "Area", tooltip: "Area" },
        {
          id: 11,
          key: "static",
          field: "Sell-Out-Reference",
          tooltip: "Predictive Sell-Out volume at last observed price",
        },
        {
          id: 12,
          key: "retailer_groups",
          field: "Retailer-Group",
          tooltip: "Retailer Group",
        },
      ]
    : [
        {
          id: 1,
          key: "date",
          field: "Date",
          tooltip: "Date",
        },
        { id: 2, key: "product", field: "Product", tooltip: "Product" },
        { id: 3, key: "product", field: "Product UPC", tooltip: "Product UPC" },
        { id: 4, key: "retailer", field: "Retailer", tooltip: "Retailer" },
        { id: 5, key: "category", field: "Category", tooltip: "Category" },
        { id: 6, key: "line", field: "Line", tooltip: "Line" },
        { id: 7, key: "brand", field: "Brand", tooltip: "Brand" },
        { id: 8, key: "area", field: "Area", tooltip: "Area" },
        checkboxChecked === true
          ? {
              id: 9,
              key: "staticTwo",
              field: "Sellout Worse - Low Units",
              tooltip: "Sellout Worse - Low Units",
            }
          : {
              id: 10,
              key: "staticTwo",
              field: "Avg Sellout Worse - Low Units",
              tooltip: `Average Sellout Worse - Low Units ${minDateFormat}-${maxDateFormat}`,
            },
        checkboxChecked === true
          ? {
              id: 11,
              key: "staticTwo",
              field: "Sellout Optimistic - Mid Units",
              tooltip: "Sellout Optimistic - Mid Units",
            }
          : {
              id: 12,
              key: "staticTwo",
              field: "Avg Sellout Optimistic - Mid Units",
              tooltip: `Average Sellout Optimistic - Mid Units ${minDateFormat}-${maxDateFormat}`,
            },
        checkboxChecked === true
          ? {
              id: 13,
              key: "staticTwo",
              field: "Sellout Probable - High Units",
              tooltip: "Sellout Probable - High Units",
            }
          : {
              id: 14,
              key: "staticTwo",
              field: "Avg Sellout Probable - High Units",
              tooltip: `Average Sellout Probable - High Units ${minDateFormat}-${maxDateFormat}`,
            },
        {
          id: 15,
          key: "retailer_groups",
          field: "Retailer-Group",
          tooltip: "Retailer Group",
        },
      ];

  const [fields, setFields] = React.useState(staticFields);

  useEffect(() => {
    setFields(staticFields);
  }, [minDate, maxDate]);

  const staticOptions = [
    {
      key: null,
      label: "-",
    },
    {
      key: "category",
      label: "By Category",
      icon: <AiOutlineTags size={22} />,
    },
    {
      key: "line",
      label: "By Line",
      icon: <AiOutlineTags size={22} />,
    },
    {
      key: "brand",
      label: "By Brand",
      icon: <AiOutlineTags size={22} />,
    },
    {
      key: "product",
      label: "By Product",
      icon: <AiOutlineTags size={22} />,
    },
    {
      key: "retailer",
      label: "By Retailer",

      icon: <AiOutlineShop size={22} />,
    },
    {
      key: "retailer_groups",
      label: "By Retailer Group",

      icon: <AiOutlineShop size={22} />,
    },
    {
      key: "area",
      label: "By Area",

      icon: <GoLocation size={22} />,
    },
  ];

  const [selectOptions, setSelectOptions] = React.useState(staticOptions);

  const handleExportExcel = () => {
    handleClose();
  };

  const handleCloseButton = () => {
    handleClose();
  };

  useEffect(() => {
    const notSelectedGroupBy = _.filter(
      [...staticOptions],
      (option) =>
        option.key !== excelGroupBy.key && option.key !== excelGroupByTwo.key
    );

    const selectedField = _.filter(
      [...staticFields],
      (option) =>
        option.key === excelGroupBy.key ||
        option.key === excelGroupByTwo.key ||
        option.key === "static" ||
        option.key === "staticTwo" ||
        (checkboxChecked ? option.key === "date" : option.key === "")
    );

    setFields(selectedField);
    setSelectOptions(notSelectedGroupBy);
  }, [excelGroupBy, excelGroupByTwo, checkboxChecked, minDate, maxDate]);

  const handleByDate = (e) => {
    setCheckboxChecked(e.target.checked);
  };

  const buttonWithBehavior = (
    withFunction,
    excelGroupByParam,
    excelGroupByTwoParam,
    dateChecked,
    dateMin,
    dateMax
  ) =>
    withFunction(
      (p) => (
        <Button
          autoFocus
          variant="contained"
          color="primary"
          disableRipple
          onClick={(e) => {
            e.stopPropagation();
            p.onClick(e);
            handleExportExcel();
          }}
        >
          EXPORT
        </Button>
      ),
      excelGroupByParam,
      excelGroupByTwoParam,
      dateChecked,
      dateMin,
      dateMax
    );

  const ButtonWithExportElasticities = buttonWithBehavior(
    withExportElasticities,
    excelGroupBy,
    excelGroupByTwo,
    checkboxChecked,
    minDate,
    maxDate
  );

  const ButtonWithExportPredictions = buttonWithBehavior(
    withExportDemandPredictions,
    excelGroupBy,
    excelGroupByTwo,
    checkboxChecked,
    minDate,
    maxDate
  );

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      disableRestoreFocus
      classes={{
        paperWidthMd: classes.dialogRoot,
      }}
    >
      <StyledDialogTitle className={classes.dialogTitle}>
        {isDemandPlanning ? (
          <div className={classes.dialogText}>Export Predictions</div>
        ) : (
          <>
            <div className={classes.dialogText}>Export Elasticities</div>
            <ElasticityTypeToggle />
          </>
        )}
      </StyledDialogTitle>
      <DialogContent
        className={
          isSmallScreen ? classes.dialogContentSmall : classes.dialogContent
        }
      >
        <StyledInputLabel
          id="selectLabel"
          className={classes.inputLabelAggregation}
        >
          Aggregation Level
        </StyledInputLabel>
        <div className={classes.inputSelectContainer}>
          <SelectComponent
            selectValue={excelGroupBy}
            setSelectValue={setExcelGroupBy}
            selectTitle=""
            selectOptions={selectOptions}
            className={classes.inputSelect}
          />
        </div>
        <div className={classes.inputSelectContainer}>
          <SelectComponent
            selectValue={excelGroupByTwo}
            setSelectValue={setExcelGroupByTwo}
            selectTitle=""
            selectOptions={selectOptions}
          />
        </div>
        <div className={classes.ckeckByDate}>
          <CheckboxComponent
            label="By Date"
            labelPlacement="end"
            checkboxOnchange={(e) => handleByDate(e)}
            checkboxName="dialogCheckbox"
            checkboxSize="medium"
            checkboxColor="primary"
            checkboxDefaultChecked
          />
        </div>
        <StyledInputLabel id="selectLabel" className={classes.inputLabel}>
          Fields Preview
        </StyledInputLabel>
        <ExportPreview fieldsData={fields} />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button autoFocus onClick={() => handleCloseButton()}>
          CLOSE
        </Button>
        {isDemandPlanning ? (
          <ButtonWithExportPredictions />
        ) : (
          <ButtonWithExportElasticities />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ExportElasticitiesCard;
